import React from 'react'
import logoimg from "../images/logo.jpg"

function Logo() {
  return (
    <h1 style={{margin:0}} className='Logo'>Chachia <span>Design</span></h1>
  )
}

export default Logo